
import { Module } from '../core';

import closeMultiScene from './commands/closeMultiScene';
import setMapCenterByMultiScene from './commands/setMapCenterByMultiScene';
import showPosition from './commands/showPosition';

export default class ModuleMapMultiScene extends Module {

    constructor() {
        super('mapmultiscene');
    }

    initCommands() {
        this.addCommand(closeMultiScene);
        this.addCommand(setMapCenterByMultiScene);
        this.addCommand(showPosition);
    }
}
